export default "__VITE_ASSET__5bf23b35__"